import React from 'react';
import { Agreements } from '../../../../types/Agreements.types';
import { AgreementsTableHeader } from './AgreementsTableHeader';
import { AgreementsTableRow } from './AgreementsTableRow';
import { Table, TableHead, TableBody } from '@mui/material';

interface AgreementsTableDesktopProps {
  agreements: Agreements[];
  order: 'asc' | 'desc';
  orderBy: keyof Agreements;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Agreements
  ) => void;
  onRowClick: (agreementId: string) => void;
}

export const AgreementsTableDesktop = ({
  agreements,
  order,
  orderBy,
  onRequestSort,
  onRowClick,
}: AgreementsTableDesktopProps) => {
  return (
    <Table
      sx={{
        minWidth: 650,
      }}
      aria-label="Agreements list"
    >
      <TableHead>
        <AgreementsTableHeader
          order={order}
          orderBy={orderBy}
          onRequestSort={onRequestSort}
        />
      </TableHead>
      <TableBody>
        {agreements?.map((agreement) => (
          <AgreementsTableRow
            key={agreement._id}
            agreement={agreement}
            onRowClick={onRowClick}
          />
        ))}
      </TableBody>
    </Table>
  );
};
